import { render } from "./ConfirmRegistration.vue?vue&type=template&id=263dafb4&ts=true"
import script from "./ConfirmRegistration.vue?vue&type=script&lang=ts"
export * from "./ConfirmRegistration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__